import axios from "axios";
import router from "./index";

// Ajustado para '/api' para usar corretamente o proxy do vue.config.js
const Url = "/api";

const axiosInstance = axios.create({
  baseURL: Url,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

axiosInstance.interceptors.request.use(
  (config) => {
    const publicRoutes = [
      "/asas/login",
      "/asas/verificarUsuarioLti",
      "/portal/ValidarAcessobiblioteca",
      "/asas/usuario/refresh",
      "/asas/usuario/logout",
    ];
    const isPublicRoute = publicRoutes.some((route) =>
      config.url?.includes(route),
    );

    if (!isPublicRoute) {
      const token = localStorage.getItem("token");

      if (token && token !== "0") {
        config.headers.Authorization = `Bearer ${token}`;
      } else {
        console.log("[axios] Requisição para:", config.url, "SEM token");
      }
    } else {
      console.log("[axios] Rota pública:", config.url, "- não enviando token");
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const status = error.response?.status;
    const url = error.config?.url;
    const originalRequest = error.config;

    console.error("[axios] Erro", status, "em:", url);

    if (status === 500 && !originalRequest._retry) {
      const isLoginEndpoint =
        url?.includes("/asas/login") ||
        url?.includes("/asas/verificarUsuarioLti");

      if (isLoginEndpoint) {
        originalRequest._retry = true;
        console.warn(
          "[axios] Erro 500 em endpoint de login, tentando novamente...",
        );

        localStorage.removeItem("token");
        localStorage.removeItem("user");

        await new Promise((resolve) => setTimeout(resolve, 500));

        try {
          return await axiosInstance.request(originalRequest);
        } catch (retryError) {
          return Promise.reject(retryError);
        }
      }
    }

    if (
      status === 401 &&
      !originalRequest._retry &&
      !url?.includes("/login") &&
      !url?.includes("/refresh")
    ) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = "Bearer " + token;
            return axiosInstance(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const response = await axiosInstance.post("/asas/usuario/refresh");

        const { token } = response.data;

        if (!token) {
          throw new Error("Token não retornado pelo endpoint de refresh");
        }

        localStorage.setItem("token", token);
        axiosInstance.defaults.headers.common["Authorization"] =
          "Bearer " + token;

        console.log("[axios] Token renovado com sucesso");

        processQueue(null, token);

        originalRequest.headers["Authorization"] = "Bearer " + token;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        console.error(
          "[axios] Falha ao renovar token:",
          refreshError.response?.status || refreshError.message,
        );

        processQueue(refreshError, null);
        localStorage.removeItem("token");
        localStorage.removeItem("user");

        if (
          router.currentRoute.path !== "/" &&
          router.currentRoute.path !== "/login"
        ) {
          router.push("/").catch(() => {});
        }

        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    if (status === 403) {
      const currentPath = router.currentRoute?.path;

      if (
        currentPath &&
        currentPath !== "/" &&
        currentPath !== "/login" &&
        currentPath !== "/auth"
      ) {
        console.warn(
          "[axios] Acesso negado (403), removendo token e redirecionando para login",
        );
        localStorage.removeItem("token");
        window.location.href = "/";
        localStorage.removeItem("user");
        router.push("/");
      }
    }

    return Promise.reject(error);
  },
);

const request = {
  post: function (url, data) {
    return axiosInstance.post(url, data);
  },
  get: function (url) {
    return axiosInstance.get(url);
  },
};

export default request;
export { Url };
